import { render } from "./AutomationTracking.vue?vue&type=template&id=31e37b30&scoped=true"
import script from "./AutomationTracking.vue?vue&type=script&lang=js"
export * from "./AutomationTracking.vue?vue&type=script&lang=js"

import "./AutomationTracking.vue?vue&type=style&index=0&id=31e37b30&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31e37b30"]])

export default __exports__